(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScheduleCommandsController', ScheduleCommandsController);

    ScheduleCommandsController.$inject = ['$state', '$uibModalInstance', 'AlertService', '$timeout', 'entity'];

    function ScheduleCommandsController($state, $uibModalInstance, AlertService, $timeout, entity) {
        var vm = this;

        vm.scheduleDate = entity;
        if(!entity.single)
            vm.multipleSchedule = entity.selectedDay;

        if(Object.keys(entity).length === 1)
            vm.multipleSchedule = [
                {day: "MON", selectedTime: ""},
                {day: "TUE", selectedTime: ""},
                {day: "WED", selectedTime: ""},
                {day: "THU", selectedTime: ""},
                {day: "FRI", selectedTime: ""},
                {day: "SAT", selectedTime: ""},
                {day: "SUN", selectedTime: ""}
            ];

        vm.repeatStatus = [false, false, false, false, false, false, false];

        vm.openTimeCal = function(index) {
            $timeout(function() {
                vm.repeatStatus[index] = true;
            });
        };

        vm.datepickerOptions = {
            minDate: null
        };

        vm.openUpCalendar = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (vm.scheduleUpDatetime) {
                vm.scheduleUpDatetime.isOpen = !vm.scheduleUpDatetime.isOpen;
            } else {
                vm.scheduleUpDatetime = {isOpen: true};
            }
        };

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.save = function () {
            if(!vm.scheduleDate.single) {
                vm.scheduleDate.selectedDay = vm.multipleSchedule;
                checkAtLeastOneValue();
            }
            $uibModalInstance.close(vm.scheduleDate);
        };

        function checkAtLeastOneValue() {
            var res = false;
            angular.forEach(vm.scheduleDate.selectedDay, function(check){
                if(check.includeDay && check.selectedTime != null) {
                    res = true;
                } else
                    check.includeDay = false;
            });
            if(!res)
                vm.scheduleDate.selectedDay = undefined;
        }

        vm.check = function (check){
            vm.scheduleDate = {};
            vm.scheduleDate.single = check;
            if(!vm.scheduleDate.single){
                vm.multipleSchedule = [
                    {day: "MON"},
                    {day: "TUE"},
                    {day: "WED"},
                    {day: "THU"},
                    {day: "FRI"},
                    {day: "SAT"},
                    {day: "SUN"}
                ];
                vm.datepickerOptions = {
                    minDate: null
                };
            } else {
                vm.multipleSchedule = [];
                vm.datepickerOptions = {
                    minDate: new Date()
                };
            }
        }
    }
})();
